export default __webpack_public_path__ + "assets/e4887b01cbd7604729bd88acc91bf6b6.svg";